import { partyLabel, TICK_MS } from "@pd/shared";

/** Floor-end and nearby-run times use the same authoritative tick unit. */
export function formatRunTime(ticks: number): string {
  const seconds = Math.floor(ticks * TICK_MS / 1000);
  const minutes = Math.floor(seconds / 60);
  const ss = String(seconds % 60).padStart(2, "0");
  if (minutes < 60) return `${String(minutes).padStart(2, "0")}:${ss}`;
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}:${ss}`;
}

/** A rank is among clear times in this floor-type/finishing-party bucket,
 * not among the individual players in the latest run. */
export function formatRunRank(rank: number, total: number, floorName: string, partySize: number, size?: string): string {
  // The same words the boards use, so the results screen and the record book
  // name the board alike.
  const party = partyLabel(partySize).toLowerCase();
  // The board's bucket is floor type × size × party size — name the size
  // (the client's own, from the floor Welcome) so the placement reads as
  // what it is.
  const bucket = size ? `${size} · ${party}` : party;
  return `You claimed #${rank} of ${total} on ${floorName || "this floor"} (${bucket})`;
}
